import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { MatButtonModule } from '@angular/material';
import { NotificationsComponent } from './notifications/notifications.component';
import { VideosNavbarComponent } from './videos-navbar/videos-navbar.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { UsrinfoComponent } from './usrinfo/usrinfo.component';
import { MatTabsModule } from '@angular/material/tabs';


@NgModule({
    imports: [ RouterModule, CommonModule, MatButtonModule, MatTabsModule],
    declarations: [ NavbarComponent, NotificationsComponent, VideosNavbarComponent , BreadcrumbComponent, UsrinfoComponent],
    exports: [ NavbarComponent, NotificationsComponent, VideosNavbarComponent,BreadcrumbComponent  ]
})

export class NavbarModule {}
